<app-base-modal
  [title]="'Даты в расчетах'"
>
  <div class="dates-calculations">
    @for (date of dates(); track $index) {
      <div class="dates-calculations-item">
        {{ getDisplayDate(date) }}
      </div>
    }
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
